module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_6005.d6cddae3.png";